import styled, { css } from 'styled-components';

export const FadeContainer = styled.div`
  transition: opacity ${(props) => props.timeout}ms ease-in-out;
  opacity: ${(props) => (props.state === 'entered' ? 1 : 0)};
  height: 100%;
  width: 100%;

  ${(props) =>
    props.state === 'exiting' &&
    props.absolute &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    `}
`;
